import { Footer, Header, mountHeader, mountThemeToggle } from "@pinaroyalcargo/shared-ui";

const routes = [
  { path: "/", page: () => import("./pages/home.page.js") },
  { path: "/services", page: () => import("./pages/services.page.js") },
  { path: "/about", page: () => import("./pages/about.page.js") },
  { path: "/contact", page: () => import("./pages/contact.page.js") },
  { path: "/track", page: () => import("./pages/track.page.js") },
  { path: "/terms-conditions", page: () => import("./pages/terms-conditions.page.js") },
  { path: "/privacy-policy", page: () => import("./pages/privacy-policy.page.js") },
  { path: "/refund-policy", page: () => import("./pages/refund-policy.page.js") },
  { path: /^\/track\/([^/]+)\/details$/, page: () => import("./pages/track-details.page.js") },
  { path: /^\/track\/([^/]+)$/, page: () => import("./pages/track-result.page.js") },
];

function renderShell(pageHtml, pathname) {
  return `${Header("public", pathname)}${pageHtml}${Footer()}`;
}

export async function renderRoute(pathname, root) {
  for (const route of routes) {
    const match = typeof route.path === "string" ? pathname === route.path : route.path.exec(pathname);
    if (match) {
      const mod = await route.page();
      root.innerHTML = renderShell(mod.render(match[1]), pathname);
      mountHeader(root);
      mountThemeToggle(root);
      mod.mount?.(root, match[1]);
      return;
    }
  }

  const mod = await import("./pages/not-found.page.js");
  root.innerHTML = renderShell(mod.render(), pathname);
  mountHeader(root);
  mountThemeToggle(root);
}

export function initRouter(root) {
  renderRoute(window.location.pathname, root);
  window.addEventListener("popstate", () => renderRoute(window.location.pathname, root));

  document.addEventListener("click", (e) => {
    const link = e.target.closest("a[data-link]");
    if (!link) return;

    e.preventDefault();
    const url = new URL(link.href);
    window.history.pushState({}, "", `${url.pathname}${url.hash}`);
    renderRoute(url.pathname, root);
  });
}
